<template>
  <div
    class="flex min-h-screen flex-col items-center justify-center bg-gray-100 px-5 py-8 text-lg"
  >
    <AppiconsLoader class="mx-auto h-24 w-24 animate-spin text-primary-600" />
  </div>
</template>
